import { ExtensionService, provideExtensionConfig } from '@alfresco/adf-extensions';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { CoreModule, TranslationService } from '@alfresco/adf-core';
import { AldenLoginComponent } from './components/login/login.component';
import { AldenLogoutComponent } from './components/logout/logout.component';
import { RouterModule } from '@angular/router';
import { routes } from '../alden.routes';
import { DatePipe } from '@angular/common';
import {
  LockedByModule,
  PageLayoutModule, SharedDirectivesModule, SharedInfoDrawerModule, SharedModule, SharedToolbarModule } from '@alfresco/aca-shared';
import { ContentModule } from '@alfresco/adf-content-services';
import { ViewProfileComponent } from './components/view-profile/view-profile.component';
import { EffectsModule } from '@ngrx/effects';
import { SMTSearchEffects } from './store/effects/search.effects';
import { AldenContentUrlService } from './services/alden-content-url.service';
import { CustomListTableComponent } from './components/custom-list/custom-list-table/custom-list-table.component';
import { CustomListComponent } from './components/custom-list/custom-list.component';
import { ClearFiltersComponent } from './components/custom-list/templates/actions/clear-filters/clear-filters.component';
import { ExcelExportComponent } from './components/custom-list/templates/actions/excel-export/excel-export.component';
import { TooltipDirective } from './directives/tooltip-template-directive.component';
import { RenditionPipe } from './pipes/rendition.pipe';
import { CustomListQueryBuilderService } from './services/custom-list-query-builder.service';
import { CustomListService } from './services/custom-list.service';
import { SmtActionsService } from 'projects/alden-extension/src/lib/services/actions.service';
import { KeyValuePipe } from './pipes/key-value.pipe';
import { SMTActionsEffects } from './store/effects/actions.effects';
import { AppCommonModule } from 'app/src/app/components/common/common.module';
import { ExcelExportDialog } from './dialogs/excel-export/excel-export.dialog';
import { ExcelExportWarningDialog } from './dialogs/excel-export/excel-export-warning.dialog';
import { DownloadSizeWarningDialog } from './dialogs/download-all/download-size-warning.dialog';
import { SMTAldenEffects } from './store/effects/alden.effects';
import { SizePipe } from './pipes/size.pipe';
import { MimeTypePipe } from './pipes/mime-type.pipe';
import { ChooseOptionDialogComponent } from './dialogs/choose-option/choose-option.dialog';
import { SearchSelectComponent } from './components/search-select/search-select.component';
import { DownloadAllComponent } from './components/custom-list/templates/actions/download-all/download-all.component';
import { DownloadAllDialog } from './dialogs/download-all/download-all.dialog';
import { ColumnValuePipe } from './pipes/column-value.pipe';
import { SMTDataListsService } from './services/data-lists.service';
import { FileInputComponent } from './components/file-input/file-input.component';
import { DndDirective } from './directives/dnd.directive';
import { DateInputComponent } from './components/date-input/date-input.component';
import { CustomSearchFilterComponent } from './components/custom-list/custom-search-filter/custom-search-filter.component';
import { SMTSearchWidgetChipComponent } from './components/custom-list/custom-search-filter/search-widget-chip/search-widget-chip.component';
import { SMTSearchTextComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-text/search-text.component';
import { SMTSearchWidgetContainerComponent } from './components/custom-list/custom-search-filter/search-widget-container/search-widget-container.component';
import { SMTSearchDateRangeComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-date-range/search-date-range.component';
import { SMTSearchListComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-list/search-list.component';
import { SMTSearchBooleanComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-boolean/search-boolean.component';
import { SMTSearchFilterMenuCardComponent } from './components/custom-list/custom-search-filter/search-filter-menu-card/search-filter-menu-card.component';
import { ReloadTableComponent } from './components/custom-list/templates/actions/reload-table/reload-table.component';
import { ShowFilterHeaderComponent } from './components/custom-list/templates/actions/show-filter-header/show-filter-header.component';
import { SMTConfirmDialogComponent } from './dialogs/confirm/confirm.dialog';
import { SMTSearchTextPrequeryComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-text-prequery/search-text-prequery.component';
import { AldenService } from './services/alden.service';
import { SMTAboutDialogComponent } from './dialogs/about/about.dialog';
import { SMTLoadingDialogComponent } from './dialogs/loading/loading.dialog';
import { SearchSelectDirective } from './directives/search-select.directive';
import { AldenMaterialModule } from './material.module';
import { CustomRuleContext } from './models/custom-rule-context';
import { SMTUsersService } from './services/users-service';
import { TaxonomyWrapperModule } from './wrappers/taxonomy/taxonomy-wrapper.module';
import { LoginAldenComponent } from './components/login/login-alden.component';
import { BasicDialog } from './dialogs/basic/basic.dialog';
import { CustomActionsColumnComponent } from './components/custom-list/custom-list-table/custom-column-actions/custom-column-actions.component';
import { SMTThumbnailComponent } from './components/custom-list/templates/thumbnail/thumbnail.component';
import { SMTSearchTextMultiPropertyComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-text-multi-property/search-text-multi-propertycomponent';
import { SMTSearchListMultiPropertyComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-list-multi-property/search-list-multi-property.component';
import { CustomActionComponent } from './components/custom-action/custom-action.component';
import { CustomActionInlineComponent } from './components/custom-action/inline/custom-action-inline.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { InitService } from './services/init.service';
import { LoginService } from './services/login.service';
import { AldenSearchResultsModule } from './components/search/search-results.module';
import { SearchResultsComponent } from './components/search/search-results/search-results.component';
import { InputComponent } from './components/input/input.component';
import { BooleanComponent } from './components/boolean/boolean.component';
import { SMTSearchUserComponent } from './components/custom-list/custom-search-filter/custom-search-widgets/search-user/search-user.component';
import { SearchPeopleSelectComponent } from './components/search-people-select/search-people-select.component';
import { ProfileGuard } from './guards/profile.guard';
import { CustomUserPreferencesService } from './services/custom-user-preferences-service';
import { SaveViewerConfigHeaderComponent } from './components/custom-list/templates/actions/save-viewer-config/save-viewer-config-header.component';
import { SMTConfigDialogComponent } from './dialogs/config/config.dialog';

import { PipeServiceImpl } from 'pipe-service/pipe-service-impl';
import { IntegrationServiceImpl } from 'integration-service/integration-service-impl';

import * as rulesAlden from './rules/alden.rules';


export function initializeApp(initService: InitService): () => Promise<void> {
  return (): Promise<void> => initService.initApp();
}

@NgModule({
  declarations: [
    LoginAldenComponent,
    AldenLoginComponent,
    AldenLogoutComponent,
    ViewProfileComponent,
    CustomListComponent,
    CustomListTableComponent,
    ClearFiltersComponent,
    ReloadTableComponent,
    ShowFilterHeaderComponent,
    ExcelExportComponent,
    TooltipDirective,
    KeyValuePipe,
    RenditionPipe,
    ExcelExportDialog,
    ExcelExportWarningDialog,
    DownloadSizeWarningDialog,
    SizePipe,
    MimeTypePipe,
    ChooseOptionDialogComponent,
    SearchSelectComponent,
    SearchPeopleSelectComponent,
    DownloadAllComponent,
    DownloadAllDialog,
    ColumnValuePipe,
    FileInputComponent,
    DndDirective,
    DateInputComponent,
    InputComponent,
    BooleanComponent,
    CustomSearchFilterComponent,
    SMTSearchWidgetChipComponent,
    SMTSearchWidgetContainerComponent,
    SMTSearchFilterMenuCardComponent,
    SMTSearchTextComponent,
    SMTSearchDateRangeComponent,
    SMTSearchListComponent,
    SMTSearchBooleanComponent,
    SMTConfirmDialogComponent,
    SMTSearchTextPrequeryComponent,
    SMTAboutDialogComponent,
    SMTLoadingDialogComponent,
    SearchSelectDirective,
    BasicDialog,
    CustomActionsColumnComponent,
    CustomActionComponent,
    CustomActionInlineComponent,
    SMTThumbnailComponent,
    SMTSearchTextMultiPropertyComponent,
    SMTSearchListMultiPropertyComponent,
    InputComponent,
    SMTSearchUserComponent,
    SaveViewerConfigHeaderComponent,
    SMTConfigDialogComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    EffectsModule.forFeature([
      SMTSearchEffects,
      SMTActionsEffects,
      SMTAldenEffects
    ]),
    CoreModule.forChild(),
    AppCommonModule,
    ContentModule.forChild(),
    SharedModule,
    SharedToolbarModule,
    SharedInfoDrawerModule,
    PageLayoutModule,
    AldenMaterialModule,
    TaxonomyWrapperModule,
    SharedDirectivesModule,
    FlexLayoutModule,
    AldenSearchResultsModule,
    LockedByModule
  ],
  exports: [
    LoginAldenComponent,
    AldenLoginComponent,
    AldenLogoutComponent,
    ViewProfileComponent,
    CustomListTableComponent,
    CustomListComponent,
    TooltipDirective,
    DndDirective,
    KeyValuePipe,
    RenditionPipe,
    DownloadAllDialog,
    SizePipe,
    MimeTypePipe,
    ColumnValuePipe,
    ChooseOptionDialogComponent,
    SearchSelectComponent,
    SearchPeopleSelectComponent,
    DownloadAllDialog,
    FileInputComponent,
    DateInputComponent,
    InputComponent,
    BooleanComponent,
    SMTConfirmDialogComponent,
    CustomActionsColumnComponent,
    CustomActionComponent,
    CustomActionInlineComponent,
    InputComponent,
    AldenMaterialModule,
    FlexLayoutModule
  ],
  providers: [
    provideExtensionConfig(['alden.extension.json']),
    InitService,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [InitService], multi: true },
    LoginService,
    AldenService,
    AldenContentUrlService,
    CustomListQueryBuilderService,
    CustomListService,
    KeyValuePipe,
    RenditionPipe,
    SmtActionsService,
    SizePipe,
    MimeTypePipe,
    ColumnValuePipe,
    DatePipe,
    SMTDataListsService,
    PipeServiceImpl,
    IntegrationServiceImpl,
    SMTUsersService,
    CustomUserPreferencesService
  ],
})
export class AldenExtensionModule {
  constructor(extensions: ExtensionService, translation: TranslationService, private aldenService: AldenService, private injector: Injector, private customListService: CustomListService) {
      translation.addTranslationFolder('alden-extension', 'assets/alden-extension');

      extensions.setComponents({
        'app.logout': AldenLogoutComponent,
        'alden-profile': ViewProfileComponent,
        'alden-search': SearchResultsComponent,
        'smt-action-clear-filters.component': ClearFiltersComponent,
        'smt-action-show-filter-header.component': ShowFilterHeaderComponent,
        'smt-action-reload-table.component': ReloadTableComponent,
        'smt-action-excel-export.component': ExcelExportComponent,
        'smt-action-download-all.component': DownloadAllComponent,
        'smt-column-actions.component': CustomActionsColumnComponent,
        'smt-custom-action.component': CustomActionComponent,
        'smt-custom-action-inline.component': CustomActionInlineComponent,
        'smt-thumbnail.component': SMTThumbnailComponent,
        'smt-action-save-viewer-config-header.component': SaveViewerConfigHeaderComponent
      });

      extensions.setAuthGuards({
        'alden.profile.auth': ProfileGuard,
      });

      extensions.setEvaluators({
        'app.selection.canDelete': rulesAlden.canDeleteSelection,
        'alden.navigation.isViewer': rulesAlden.isViewer,
        'alden.isAlden': (context: CustomRuleContext) => {
          return rulesAlden.isAlden(context, this.injector);
        },
        'alden.isAdmin': () => {
          return rulesAlden.isAdmin(this.aldenService.profile);
        },
        'alden.canModifyStructure': rulesAlden.isAlden && rulesAlden.canModifyStructure,
        'alden.hasNotDefaultValue': (context: CustomRuleContext) => {
          return rulesAlden.hasNotDefaultValue(context);
        },
        'alden.canDownloadAll': (context: CustomRuleContext) => {
          return rulesAlden.canDownloadAll(context, this.customListService);
        },
        'alden.canExcelExport': (context: CustomRuleContext) => {
          return rulesAlden.canExcelExport(context, this.customListService);
        },
        'alden.location': rulesAlden.showLocation,
        'alden.isEflowEnabled': () => {
          return rulesAlden.isEflowEnabled(aldenService);
        },
        'alden.isBuilderEnabled': () => {
          return rulesAlden.isBuilderEnabled(aldenService);
        },
        'alden.isSignaformEnabled': () => {
          return rulesAlden.isSignaformEnabled(aldenService);
        },
        'alden.isTaxonomyEnabled': () => {
          return rulesAlden.isTaxonomyEnabled(aldenService);
        },
        'alden.isSignEnabled': () => {
          return rulesAlden.isSignEnabled(aldenService);
        },
        'alden.isEniEnabled': () => {
          return rulesAlden.isEniEnabled(aldenService);
        },
      });
    }
}
